import React from "react";
import {
  Box,
  Container,
  Typography,
  makeStyles,
  Button,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  BestSellerBox: {
    padding: "75px 0",
    [theme.breakpoints.down("sm")]: {
      padding: "50px 0px 25px",
    },
    "& .updateSection": {
      padding: "50px",
      background: theme.palette.background.blur,
      position: "relative",
      borderRadius: "5px",
      [theme.breakpoints.down("sm")]: {
        padding: "50px 10px",
      },
      "& h1": {
        "& span": { color: "#22A7F0" },
      },
      "& p": {
        maxWidth: "370px",
        marginBottom: "30px",
      },
    },
  },
}));

export default function LearnMoreContent(props) {
  const classes = useStyles();

  return (
    <Box className={classes.BestSellerBox}>
      <Container>
        <Box className="borderShadowBox">
          <Box className="updateSection">
            <Typography
              variant="h1"
              color="primary"
              style={{ textAlign: "center" }}
            >
              Access to <span>APIs</span>, Documentation, <span>SDK</span>{" "}
              implemenation and <span>API key</span> generation in one place.
            </Typography>
            <Box mt={2} display="flex" style={{ justifyContent: "center" }}>
              <Box>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    window.open("https://sdk.hovr.site/");
                  }}
                >
                  Learn More
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
